import { Extension } from "@tiptap/core";

export const LinkPortalExtension = Extension.create({
    onBeforeCreate({ editor }) {
        // Before the view is created.
    },
    onCreate({ editor }) {
        // The editor is ready.
    },
    onUpdate({ editor }) {
        const onDetectLinks = this.options.onDetectLinks;
        const links = [];
        editor.state.doc.descendants((node, pos, parent) => {
            for (const mark of node.marks) {
                if (mark.type.name === "link") {
                    links.push(mark.attrs.href);
                }
            }
            return true;
        });
        onDetectLinks(links);
    },
    onSelectionUpdate({ editor }) {
        // The selection has changed.
    },
    onTransaction({ editor, transaction }) {},
    onFocus({ editor, event }) {
        // The editor is focused.
    },
    onBlur({ editor, event }) {
        // The editor isn’t focused anymore.
    },
    onDestroy() {
        // The editor is being destroyed.
    },
});
